import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CommonContainer } from './styles';
import Avatar from '../../../shared/avatar';
import { recordStatisticsEvent } from '../../../../services/statistics-service';
import { defaultFundManagerTitle } from '../../../shared/consts';

const Container = styled(CommonContainer)`
  border-top: 0px;
  margin-top: 0px;
  margin-bottom: 48px;
  padding: 0;
  ${props => props.theme.isMobile && `
    margin-bottom: 16px;
  `};
`;

const Manager = styled.div`
  display: flex;
  align-items: center;
  ${props => props.theme.isMobile && `
    margin-bottom: 40px;
  `};

  & > a {
    flex-shrink: 0;
    margin-right: ${props => (((!props.theme.isXXLarge && props.theme.isXLarge) || props.theme.isMobile) ? 16 : 24)}px;

    > img {
      width: ${props => ((!props.theme.isXXLarge && props.theme.isXLarge) ? 72 : 88)}px;
      height: ${props => ((!props.theme.isXXLarge && props.theme.isXLarge) ? 72 : 88)}px;
      margin-right: 0;
      border-radius: 4px;
      border: 2px solid white;
      box-shadow: 0px 2.73684px 5.47368px rgba(50, 50, 71, 0.2);
    }
  }
`;

const VFlex = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 100%;
`;

const HFlex = styled.div`
  display: flex;
  align-items: baseline;
`;

const Name = styled.a`
  font: ${props => props.theme.fontWeightBold} 19px/21px ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.bodyColor};
  min-width: 58px;
`;

const text = styled.span`
  font-size: 14px;
  font-weight: ${props => props.theme.fontWeightMedium};
`;

const Position = styled(text)`
  color: ${props => props.theme.bodyColor};
`;

const Company = styled(text)`
  color: #627484;
`;

export default function Managers({ id, members, company }) {
  if (members.length === 0) {
    return null;
  }

  const handleClick = e => {
    let { target } = e;

    while (!target.getAttribute('href')) {
      target = target.parentElement;
    }

    recordStatisticsEvent({
      id,
      statisticable: 'fund',
      event: 'fund_profile_contributor_view',
      clicked_url: target.getAttribute('href'),
      page: `${window.location.pathname}#investing-with`,
    });

    return false;
  };

  return (
    <Container>
      {members.slice(0, 2).map(m => (
        <Manager key={m.slug}>
          <Avatar {...m} clickHandler={handleClick} />
          <VFlex>
            <HFlex>
              <Name href={m.slug ? `/contributors/${m.slug}` : '#'}>{m.name}</Name>
            </HFlex>
            {!!m.position && <Position>{m.position}</Position>}
            {!m.position && <Position>{defaultFundManagerTitle}</Position>}
            <Company>{company.name}</Company>
          </VFlex>
        </Manager>
      ))}
    </Container>
  );
}

Managers.propTypes = {
  id: PropTypes.number.isRequired,
  company: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  members: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    profilePictureUrl: PropTypes.string,
    position: PropTypes.string,
  })).isRequired,
};
